<template>
    <!-- 答案页码内容页面 -->
    <div class="box">
        <div
            class="box-imgbox"
            v-for="(item, index) in bookImgs"
            :key="index"
        >
            <img class="img" :src="item" alt="">
        </div>
        <div class="page-btn">{{$route.query.pageName}}</div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import {answerPageDetail} from '@/api/api';

@Options({
    components: {
    },
    created() {
        this.answerPageDetail();
    }
})
export default class AnswerList extends Vue {
    bookImgs = [];

    async answerPageDetail() {
        const {pageId, type, level} = this.$route.query;
        const res = await answerPageDetail({
            pageId,
            type,
            level
        });
        if (res.code === '0') {
            this.bookImgs = res.data?.pageDetail?.imageList;
        }
        else {
            this.$toast(res.msg);
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100vw;
    min-height: 100vh;
    padding: .64rem .43rem 2rem;
    box-sizing: border-box;

    &-imgbox {
        width: 9.15rem;
        padding: .53rem .5rem;
        border-radius: .32rem;
        border: .01rem solid #F1F1F1;
        box-sizing: border-box;
        margin-bottom: .64rem;

        .img {
            width: 8.15rem;
        }
    }

    .page-btn {
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.13rem;
        height: .85rem;
        background: #0CC865;
        border-radius: .21rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: .4rem;
        color: #FFFFFF;
        font-style: normal;
    }
}

</style>
